import PropTypes from 'prop-types';
import { Container, Alert, AlertTitle } from '@material-ui/core';
import usePermissions from '../hooks/usePermissions';

// ----------------------------------------------------------------------

PermissionGuard.propTypes = {
  permissionId: PropTypes.number,
  children: PropTypes.node
};

export default function PermissionGuard({ permissionId, children }) {
  const { hasPermission } = usePermissions();

  if (!hasPermission(permissionId)) {
    return (
      <Container sx={{ mt: 5 }}>
        <Alert severity="error">
          <AlertTitle>Permission Denied</AlertTitle>
          You do not have permission to access this page. Please contact your administrator if you believe this is an error.
        </Alert>
      </Container>
    );
  }

  return <>{children}</>;
}
